export const theme = {
  colors: {
    background: '#0A0A0A',
    text: '#FFFFFF',
    primary: '#00C8FF',
    primaryHover: '#4FD8FF',
    secondary: '#FF3366',
    accent: '#FFD700',
    dark: '#1A1A1A',
    gray: '#888888',
    border: 'rgba(255, 255, 255, 0.08)',
  },
  fonts: {
    main: "'Plus Jakarta Sans', sans-serif",
    heading: "'Clash Display', sans-serif",
  },
  breakpoints: {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },
  spacing: {
    section: '120px',
  },
};
